module.exports = __webpack_public_path__ + "img/icon_map_4_off_001.c384823e.png";